import type { ComponentProps } from 'react';

export const SliderControlRight = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      {...props}
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        clipRule='evenodd'
        d='M9.85849 5L8 6.85849L13.6415 12.5L8 18.1415L9.85849 20L17.3585 12.5L9.85849 5Z'
        fill='black'
        fillRule='evenodd'
      />
    </svg>
  );
};
